import { css } from '@/styled-system/css';

export const gridContentStyles = css.raw({
  gridColumnEnd: 'span 4',
  padding: { base: '600', mdDown: '200' },
  border: `1px solid {colors.border.subtle}`,
  mdDown: { border: 'none' },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});
